// Register every Stimulus controller here. esbuild bundles this file, so
// registration is explicit rather than discovered from the filesystem.
import { application } from "./application"

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DetailsMemoryController from "./details_memory_controller"
application.register("details-memory", DetailsMemoryController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import CollapsibleGridController from "./collapsible_grid_controller"
application.register("collapsible-grid", CollapsibleGridController)

import BadgeDetailController from "./badge_detail_controller"
application.register("badge-detail", BadgeDetailController)
import ReloadPromptController from "./reload_prompt_controller"
application.register("reload-prompt", ReloadPromptController)
import CameraController from "./camera_controller"
application.register("camera", CameraController)

import WineFormController from "./wine_form_controller"
application.register("wine-form", WineFormController)
import CellarCsvController from "./cellar_csv_controller"
application.register("cellar-csv", CellarCsvController)

import TastingFlowController from "./tasting_flow_controller"
application.register("tasting-flow", TastingFlowController)

import DescriptorTagsController from "./descriptor_tags_controller"
application.register("descriptor-tags", DescriptorTagsController)

import BadgeUnlockController from "./badge_unlock_controller"
application.register("badge-unlock", BadgeUnlockController)

import GuestStorageController from "./guest_storage_controller"
application.register("guest-storage", GuestStorageController)

import GuestNoteController from "./guest_note_controller"
application.register("guest-note", GuestNoteController)

import GuestTransferController from "./guest_transfer_controller"
application.register("guest-transfer", GuestTransferController)

import QrCodeController from "./qr_code_controller"
application.register("qr-code", QrCodeController)

import JoinCodeController from "./join_code_controller"
application.register("join-code", JoinCodeController)

import ReferenceMapController from "./reference_map_controller"
application.register("reference-map", ReferenceMapController)
// Task 3 (trade organization and profile).
import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorSyncController from "./color_sync_controller"
application.register("color-sync", ColorSyncController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)
import SelectionController from "./selection_controller"
application.register("selection", SelectionController)

// Task 2 (trade events).
import LineupSortController from "./lineup_sort_controller"
application.register("lineup-sort", LineupSortController)

import LineupSearchController from "./lineup_search_controller"
application.register("lineup-search", LineupSearchController)

import FeedbackChartController from "./feedback_chart_controller"
application.register("feedback-chart", FeedbackChartController)

import QrImageController from "./qr_image_controller"
application.register("qr-image", QrImageController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import BatchLabelController from "./batch_label_controller"
application.register("batch-label", BatchLabelController)

// The marketing site (layouts/marketing.html.erb).
import WwwMockController from "./www_mock_controller"
application.register("www-mock", WwwMockController)
import WwwRevealController from "./www_reveal_controller"
application.register("www-reveal", WwwRevealController)
import WwwAudienceController from "./www_audience_controller"
application.register("www-audience", WwwAudienceController)
import WwwTabsController from "./www_tabs_controller"
application.register("www-tabs", WwwTabsController)

import ScaleController from "./scale_controller"
application.register("scale", ScaleController)

import PanelsController from "./panels_controller"
application.register("panels", PanelsController)
